// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"DeleteMoodModal_buttonsWrapper__ps7cW"};